/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UpdateProjectError = 'InvalidVehicleId' | 'DatesOverlap' | 'PlanningConflict' | 'IllegalForProcessingState' | 'Unknown' | 'NoProject';

export const UpdateProjectError = {
    InvalidVehicleId: 'InvalidVehicleId' as UpdateProjectError,
    DatesOverlap: 'DatesOverlap' as UpdateProjectError,
    PlanningConflict: 'PlanningConflict' as UpdateProjectError,
    IllegalForProcessingState: 'IllegalForProcessingState' as UpdateProjectError,
    Unknown: 'Unknown' as UpdateProjectError,
    NoProject: 'NoProject' as UpdateProjectError
};

